import React, { PureComponent } from 'react';
import { Table } from 'reactstrap';

export default class TableComponent extends PureComponent {
    render() {
        return (
            <Table
                className={this.props.className}
                striped={this.props.striped}
                hover={this.props.hover}
                responsive={this.props.responsive}
                style={Object.assign({}, this.props.style, this.props.responsive && { width: '100%' })}
            >
                {this.props.children}
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/table/Table.js